import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { AccountStatus } from '@/lib/api/domains/users.types'
import { PERMISSIONS } from '@/lib/rbac'
import { Users } from '@/features/users'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  username: z.string().optional().catch(''),
  q: z.string().optional().catch(''),
  status: z.array(z.nativeEnum(AccountStatus)).optional().catch([]),
  emailVerified: z
    .array(z.enum(['true', 'false']))
    .optional()
    .catch([]),
  phoneVerified: z
    .array(z.enum(['true', 'false']))
    .optional()
    .catch([]),
})

export const Route = createFileRoute('/_authenticated/users/')({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    const { auth } = useAuthStore.getState()

    // Check if user has permission to view users
    if (!auth.canAccess([PERMISSIONS.USERS.READ])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: Users,
})
